export default __webpack_public_path__ + "static/media/icon-done-black.15bafe02.svg";